import { useCallback, useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const useAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendAnalyticEvent = useCallback(
		(payload: Record<string, unknown>) => {
			createAnalyticsEvent(payload).fire();
		},
		[createAnalyticsEvent],
	);

	const clickedAIInEditorPrimaryCTA = useCallback(() => {
		sendAnalyticEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'clickedAIInEditorPrimaryCTA',
				source: 'twcg-530_confluence_ai_in_editor_eot',
			},
		});
	}, [sendAnalyticEvent]);

	const clickedEndOfTrialPrimaryCTA = useCallback(() => {
		sendAnalyticEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'clickedEndOfTrialPrimaryCTA',
				source: 'twcg-530_confluence_ai_in_editor_eot',
			},
		});
	}, [sendAnalyticEvent]);

	const dismissedAIInEditorModal = useCallback(() => {
		sendAnalyticEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'dismissedConfluenceAiInEditorModal',
				source: 'twcg-530_confluence_ai_in_editor_eot',
			},
		});
	}, [sendAnalyticEvent]);

	const dismissedEndOfTrialModal = useCallback(() => {
		sendAnalyticEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'dismissedConfluenceEndOfTrialModal',
				source: 'twcg-530_confluence_ai_in_editor_eot',
			},
		});
	}, [sendAnalyticEvent]);

	return {
		sendAnalyticEvent,
		dismissedAIInEditorModal,
		dismissedEndOfTrialModal,
		clickedAIInEditorPrimaryCTA,
		clickedEndOfTrialPrimaryCTA,
	};
};

export const ScreenEvent = ({ name }: { name: string }) => {
	const { sendAnalyticEvent } = useAnalytics();
	const hasSent = useRef(false);

	useEffect(() => {
		if (hasSent.current) return;
		hasSent.current = true;
		sendAnalyticEvent({
			type: 'sendScreenEvent',
			data: {
				name,
				source: 'twcg-530_confluence_ai_in_editor_eot',
			},
		});
	}, [sendAnalyticEvent, name]);

	return null;
};
